import MainMenuWrapper from './MainMenuWrapper';

export default MainMenuWrapper;
